import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import FormView from './views/FormView';
import SignOffView from './views/SignOffView';
import NotFoundView from './views/NotFoundView';
import PagePreviewView from './views/PagePreviewView';
import PageShareView from './views/PageShareView';

/**
 * One SPA behind two hosts: forms.eaco.me and pages.eaco.me. The prefixed
 * routes (/f, /p) work on either, so an old link never breaks; what the host
 * decides is only what a BARE slug means, which is what makes
 * pages.eaco.me/{slug} and forms.eaco.me/{slug} both read naturally.
 */
const isPagesHost = (): boolean =>
  typeof window !== 'undefined' &&
  window.location.hostname.split('.')[0].startsWith('pages');

// Keep old form links working after the /f restructure.
const LegacyFormRedirect: React.FC = () => {
  const { publicSlug } = useParams<{ publicSlug: string }>();
  return <Navigate to={`/f/${publicSlug ?? ''}`} replace />;
};
const LegacySignRedirect: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  return <Navigate to={`/f/sign/${token ?? ''}`} replace />;
};

/** A bare slug: a shared page on the pages host, a form anywhere else. */
const BareSlugRoute: React.FC = () =>
  isPagesHost() ? <PageShareView /> : <LegacyFormRedirect />;

const App: React.FC = () => (
  <Routes>
    {/* Forms */}
    <Route path="/f/sign/:token" element={<SignOffView />} />
    <Route path="/f/:publicSlug" element={<FormView />} />

    {/* Pages */}
    <Route path="/p/preview/:oid/:token" element={<PagePreviewView />} />
    <Route path="/p/:publicSlug" element={<PageShareView />} />

    {/* Legacy redirects (pre-/f links out in the wild). */}
    <Route path="/signoff/:token" element={<LegacySignRedirect />} />
    <Route path="/:publicSlug" element={<BareSlugRoute />} />

    <Route path="*" element={<NotFoundView />} />
  </Routes>
);

export default App;
